import { ElementRef } from '@angular/core';
var ButtonBusyDirective = /** @class */ (function () {
    function ButtonBusyDirective(_element) {
        this._element = _element;
    }
    Object.defineProperty(ButtonBusyDirective.prototype, "buttonBusy", {
        set: function (isBusy) {
            this.refreshState(isBusy);
        },
        enumerable: true,
        configurable: true
    });
    ButtonBusyDirective.prototype.ngOnInit = function () {
        this._button = this._element.nativeElement;
    };
    ButtonBusyDirective.prototype.ngAfterViewInit = function () {
        this._originalButtonInnerHtml = this._button.innerHTML;
    };
    ButtonBusyDirective.prototype.refreshState = function (isBusy) {
        if (!this._button) {
            return;
        }
        if (isBusy) {
            // disable button
            this._button.setAttribute('disabled', 'disabled');
            this._button.innerHTML = '<i class="fa fa-spin fa-spinner"></i>' +
                '<span>' + (this.busyText ? this.busyText : 'Processing...') + '</span>';
            this._button.setAttribute('_disabledBefore', true);
        }
        else {
            if (!this._button.getAttribute('_disabledBefore')) {
                return;
            }
            // enable button
            this._button.removeAttribute('disabled');
            this._button.innerHTML = this._originalButtonInnerHtml;
        }
    };
    return ButtonBusyDirective;
}());
export { ButtonBusyDirective };
